module.exports = __webpack_public_path__ + "img/logo2.7bdb4cd0.png";